import React from 'react';
import * as LR from 'lucide-react';

const MaterialIcon = ({ name, className, onClick }) => {
	return (
		<React.Fragment>
			{LR[name]
				? React.createElement(LR[name], {
						size: 40,
						onClick,
						className: `material-symbols-outlined ${onClick ? 'cursor-pointer hover:text-[#0089ff] transi' : ''} ${className}`,
					})
				: ''}
		</React.Fragment>
	);
};

export default MaterialIcon;
